module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.7476/img/storefront-header-blobs.svg"